import { Routes, Route, Navigate } from "react-router-dom";
import { NotFound } from "@/components/NotFound";
import SightReadingCourse from "@/courses/sight-reading/SightReadingCourse";
import { FAQ } from "@/data/faq";
import LessonRouter from "@/courses/sight-reading/LessonRouter";
import CircleOfFifthsTriads from "@/lessons/CircleOfFifthsTriads";
// Sing & Play
import SingAndPlay1 from "@/lessons/SingAndPlay1";
import SingAndPlay2 from "@/lessons/SingAndPlay2";
import SingAndPlay3 from "@/lessons/SingAndPlay3";
import SingAndPlay4 from "@/lessons/SingAndPlay4";
import SingAndPlay5 from "@/lessons/SingAndPlay5";
import SingAndPlay6 from "@/lessons/SingAndPlay6";
import SingAndPlay7 from "@/lessons/SingAndPlay7";
import SingAndPlay8 from "@/lessons/SingAndPlay8";
import SingAndPlay9 from "@/lessons/SingAndPlay9";
import SingAndPlay10 from "@/lessons/SingAndPlay10";
// Piano Foundation
import PianoFoundation1 from "@/lessons/PianoFoundation1";
import PianoFoundation2 from "@/lessons/PianoFoundation2";
import PianoFoundation3 from "@/lessons/PianoFoundation3";
import PianoFoundation4 from "@/lessons/PianoFoundation4";
import PianoFoundation5 from "@/lessons/PianoFoundation5";
import PianoFoundation6 from "@/lessons/PianoFoundation6";
import PianoFoundation7 from "@/lessons/PianoFoundation7";
import PianoFoundation8 from "@/lessons/PianoFoundation8";
import PianoFoundation9 from "@/lessons/PianoFoundation9";
import PianoFoundation10 from "@/lessons/PianoFoundation10";
import PianoFoundation11 from "@/lessons/PianoFoundation11";
import PianoFoundation12 from "@/lessons/PianoFoundation12";
import PianoFoundation13 from "@/lessons/PianoFoundation13";
import PianoFoundation14 from "@/lessons/PianoFoundation14";
import PianoFoundation15 from "@/lessons/PianoFoundation15";
import PianoFoundation16 from "@/lessons/PianoFoundation16";
import PianoFoundation17 from "@/lessons/PianoFoundation17";
import PianoFoundation18 from "@/lessons/PianoFoundation18";
import PianoFoundation19 from "@/lessons/PianoFoundation19";
import PianoFoundation20 from "@/lessons/PianoFoundation20";
import PianoFoundation21 from "@/lessons/PianoFoundation21";
import PianoFoundation22 from "@/lessons/PianoFoundation22";
import PianoFoundation23 from "@/lessons/PianoFoundation23";
import PianoFoundation24 from "@/lessons/PianoFoundation24";
import PianoFoundation25 from "@/lessons/PianoFoundation25";
import PianoFoundation26 from "@/lessons/PianoFoundation26";
import PianoFoundation27 from "@/lessons/PianoFoundation27";
import PianoFoundation28 from "@/lessons/PianoFoundation28";
import PianoFoundation29 from "@/lessons/PianoFoundation29";
import PianoFoundation30 from "@/lessons/PianoFoundation30";
import PianoFoundation31 from "@/lessons/PianoFoundation31";
import PianoFoundation32 from "@/lessons/PianoFoundation32";
import PianoFoundation33 from "@/lessons/PianoFoundation33";
import PianoFoundation34 from "@/lessons/PianoFoundation34";
import PianoFoundation35 from "@/lessons/PianoFoundation35";
// Piano Intermediate
import PianoIntermediate1 from "@/lessons/PianoIntermediate1";
import PianoIntermediate2 from "@/lessons/PianoIntermediate2";
import PianoIntermediate3 from "@/lessons/PianoIntermediate3";
import PianoIntermediate4 from "@/lessons/PianoIntermediate4";
import PianoIntermediate5 from "@/lessons/PianoIntermediate5";
import PianoIntermediate6 from "@/lessons/PianoIntermediate6";
import PianoIntermediate7 from "@/lessons/PianoIntermediate7";
import PianoIntermediate8 from "@/lessons/PianoIntermediate8";
import PianoIntermediate9 from "@/lessons/PianoIntermediate9";
import PianoIntermediate10 from "@/lessons/PianoIntermediate10";
import PianoIntermediate11 from "@/lessons/PianoIntermediate11";
import PianoIntermediate12 from "@/lessons/PianoIntermediate12";
import PianoIntermediate13 from "@/lessons/PianoIntermediate13";
import PianoIntermediate14 from "@/lessons/PianoIntermediate14";
import PianoIntermediate15 from "@/lessons/PianoIntermediate15";
import PianoIntermediate16 from "@/lessons/PianoIntermediate16";
import PianoIntermediate17 from "@/lessons/PianoIntermediate17";
import PianoIntermediate18 from "@/lessons/PianoIntermediate18";
import PianoIntermediate19 from "@/lessons/PianoIntermediate19";
import PianoIntermediate20 from "@/lessons/PianoIntermediate20";
import PianoIntermediate21 from "@/lessons/PianoIntermediate21";
import PianoIntermediate22 from "@/lessons/PianoIntermediate22";
import PianoIntermediate23 from "@/lessons/PianoIntermediate23";
import PianoIntermediate24 from "@/lessons/PianoIntermediate24";
import PianoIntermediate25 from "@/lessons/PianoIntermediate25";
import PianoIntermediate26 from "@/lessons/PianoIntermediate26";
import PianoIntermediate27 from "@/lessons/PianoIntermediate27";
// Music Theory
import MusicTheory1 from "@/lessons/MusicTheory1";
import MusicTheory2 from "@/lessons/MusicTheory2";
import MusicTheory3 from "@/lessons/MusicTheory3";
import MusicTheory4 from "@/lessons/MusicTheory4";
import MusicTheory5 from "@/lessons/MusicTheory5";
import MusicTheory6 from "@/lessons/MusicTheory6";
import MusicTheory7 from "@/lessons/MusicTheory7";
import MusicTheory8 from "@/lessons/MusicTheory8";
import MusicTheory9 from "@/lessons/MusicTheory9";
import MusicTheory10 from "@/lessons/MusicTheory10";
import MusicTheory11 from "@/lessons/MusicTheory11";
import MusicTheory12 from "@/lessons/MusicTheory12";
import MusicTheory13 from "@/lessons/MusicTheory13";
import MusicTheory14 from "@/lessons/MusicTheory14";
import MusicTheory15 from "@/lessons/MusicTheory15";
import MusicTheory16 from "@/lessons/MusicTheory16";
import MusicTheory17 from "@/lessons/MusicTheory17";
import MusicTheory18 from "@/lessons/MusicTheory18";
import MusicTheory19 from "@/lessons/MusicTheory19";
import MusicTheory20 from "@/lessons/MusicTheory20";
import MusicTheory21 from "@/lessons/MusicTheory21";
import MusicTheory22 from "@/lessons/MusicTheory22";
import MusicTheory23 from "@/lessons/MusicTheory23";
import MusicTheory24 from "@/lessons/MusicTheory24";
import MusicTheory25 from "@/lessons/MusicTheory25";
import MusicTheory26 from "@/lessons/MusicTheory26";
import MusicTheory27 from "@/lessons/MusicTheory27";
import MusicTheory28 from "@/lessons/MusicTheory28";
import MusicTheory29 from "@/lessons/MusicTheory29";
import MusicTheory30 from "@/lessons/MusicTheory30";
import MusicTheory31 from "@/lessons/MusicTheory31";
import MusicTheory32 from "@/lessons/MusicTheory32";
import MusicTheory33 from "@/lessons/MusicTheory33";
import MusicTheory34 from "@/lessons/MusicTheory34";
// Ear Training
import EarTraining1 from "@/lessons/EarTraining1";
import EarTraining2 from "@/lessons/EarTraining2";
import EarTraining3 from "@/lessons/EarTraining3";
import EarTraining4 from "@/lessons/EarTraining4";
import EarTraining5 from "@/lessons/EarTraining5";
import EarTraining6 from "@/lessons/EarTraining6";
import EarTraining7 from "@/lessons/EarTraining7";
import EarTraining8 from "@/lessons/EarTraining8";
import EarTraining9 from "@/lessons/EarTraining9";
import EarTraining10 from "@/lessons/EarTraining10";
// Staff Notation
import StaffNotation1 from "@/lessons/StaffNotation1";
import StaffNotation2 from "@/lessons/StaffNotation2";
import StaffNotation3 from "@/lessons/StaffNotation3";
import StaffNotation4 from "@/lessons/StaffNotation4";
import StaffNotation5 from "@/lessons/StaffNotation5";
import StaffNotation6 from "@/lessons/StaffNotation6";
// Data-driven fallback for brand-new lessons (no hand-built component).
import GenericLesson from "@/lessons/GenericLesson";
// Other course samples
import Beatles1 from "@/lessons/Beatles1";
import Beatles2 from "@/lessons/Beatles2";
import Beatles3 from "@/lessons/Beatles3";
import Beatles4 from "@/lessons/Beatles4";
import Beatles5 from "@/lessons/Beatles5";
import Beatles6 from "@/lessons/Beatles6";
import Beatles7 from "@/lessons/Beatles7";
import Beatles8 from "@/lessons/Beatles8";
import Beatles9 from "@/lessons/Beatles9";
import Beatles10 from "@/lessons/Beatles10";
import Beatles11 from "@/lessons/Beatles11";
import SouthIndian1 from "@/lessons/SouthIndian1";
import SouthIndian2 from "@/lessons/SouthIndian2";
import SouthIndian3 from "@/lessons/SouthIndian3";
import SouthIndian4 from "@/lessons/SouthIndian4";
import SouthIndian5 from "@/lessons/SouthIndian5";
import SouthIndian6 from "@/lessons/SouthIndian6";
import SouthIndian7 from "@/lessons/SouthIndian7";
import SouthIndian8 from "@/lessons/SouthIndian8";
import SouthIndian9 from "@/lessons/SouthIndian9";
import SouthIndian10 from "@/lessons/SouthIndian10";
import SouthIndian11 from "@/lessons/SouthIndian11";
import SouthIndian12 from "@/lessons/SouthIndian12";
import EdSheeran1 from "@/lessons/EdSheeran1";
import EdSheeran2 from "@/lessons/EdSheeran2";
import EdSheeran3 from "@/lessons/EdSheeran3";
import EdSheeran4 from "@/lessons/EdSheeran4";
import EdSheeran5 from "@/lessons/EdSheeran5";
import EdSheeran6 from "@/lessons/EdSheeran6";
import EdSheeran7 from "@/lessons/EdSheeran7";
import EdSheeran8 from "@/lessons/EdSheeran8";
import EdSheeran9 from "@/lessons/EdSheeran9";
import EdSheeran10 from "@/lessons/EdSheeran10";
import EdSheeran11 from "@/lessons/EdSheeran11";
import EdSheeran12 from "@/lessons/EdSheeran12";
import EdSheeran13 from "@/lessons/EdSheeran13";
import EdSheeran14 from "@/lessons/EdSheeran14";
import EdSheeran15 from "@/lessons/EdSheeran15";
import EdSheeran16 from "@/lessons/EdSheeran16";
import EdSheeran17 from "@/lessons/EdSheeran17";

import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { LessonThumb } from "@/components/LessonThumb";
import { LESSONS, COURSE_LABEL, COURSE_ACCENT, CourseSlug } from "@/data/lessons";

// Route table — keyed by `${courseSlug}/${lessonOrder}`
const ROUTE_MAP: Record<string, string> = {
  // Sing & Play
  "sing-and-play/1": "/lesson/sing-and-play-1",
  "sing-and-play/2": "/lesson/sing-and-play-2",
  "sing-and-play/3": "/lesson/sing-and-play-3",
  "sing-and-play/4": "/lesson/sing-and-play-4",
  "sing-and-play/5": "/lesson/sing-and-play-5",
  "sing-and-play/6": "/lesson/sing-and-play-6",
  "sing-and-play/7": "/lesson/sing-and-play-7",
  "sing-and-play/8": "/lesson/sing-and-play-8",
  "sing-and-play/9": "/lesson/sing-and-play-9",
  "sing-and-play/10": "/lesson/sing-and-play-10",
  // Piano Foundation
  "piano-foundation/1": "/lesson/piano-foundation-1",
  "piano-foundation/2": "/lesson/piano-foundation-2",
  "piano-foundation/3": "/lesson/piano-foundation-3",
  "piano-foundation/4": "/lesson/piano-foundation-4",
  "piano-foundation/5": "/lesson/piano-foundation-5",
  "piano-foundation/6": "/lesson/piano-foundation-6",
  "piano-foundation/7": "/lesson/piano-foundation-7",
  "piano-foundation/8": "/lesson/piano-foundation-8",
  "piano-foundation/9": "/lesson/piano-foundation-9",
  "piano-foundation/10": "/lesson/piano-foundation-10",
  "piano-foundation/11": "/lesson/piano-foundation-11",
  "piano-foundation/12": "/lesson/piano-foundation-12",
  "piano-foundation/13": "/lesson/piano-foundation-13",
  "piano-foundation/14": "/lesson/piano-foundation-14",
  "piano-foundation/15": "/lesson/piano-foundation-15",
  "piano-foundation/16": "/lesson/piano-foundation-16",
  "piano-foundation/17": "/lesson/piano-foundation-17",
  "piano-foundation/18": "/lesson/piano-foundation-18",
  "piano-foundation/19": "/lesson/piano-foundation-19",
  "piano-foundation/20": "/lesson/piano-foundation-20",
  "piano-foundation/21": "/lesson/piano-foundation-21",
  "piano-foundation/22": "/lesson/piano-foundation-22",
  "piano-foundation/23": "/lesson/piano-foundation-23",
  "piano-foundation/24": "/lesson/piano-foundation-24",
  "piano-foundation/25": "/lesson/piano-foundation-25",
  "piano-foundation/26": "/lesson/piano-foundation-26",
  "piano-foundation/27": "/lesson/piano-foundation-27",
  "piano-foundation/28": "/lesson/piano-foundation-28",
  "piano-foundation/29": "/lesson/piano-foundation-29",
  "piano-foundation/30": "/lesson/piano-foundation-30",
  "piano-foundation/31": "/lesson/piano-foundation-31",
  "piano-foundation/32": "/lesson/piano-foundation-32",
  "piano-foundation/33": "/lesson/piano-foundation-33",
  "piano-foundation/34": "/lesson/piano-foundation-34",
  "piano-foundation/35": "/lesson/piano-foundation-35",
  // Piano Intermediate
  "piano-intermediate/1": "/lesson/piano-intermediate-1",
  "piano-intermediate/2": "/lesson/piano-intermediate-2",
  "piano-intermediate/3": "/lesson/piano-intermediate-3",
  "piano-intermediate/4": "/lesson/piano-intermediate-4",
  "piano-intermediate/5": "/lesson/piano-intermediate-5",
  "piano-intermediate/6": "/lesson/piano-intermediate-6",
  "piano-intermediate/7": "/lesson/piano-intermediate-7",
  "piano-intermediate/8": "/lesson/piano-intermediate-8",
  "piano-intermediate/9": "/lesson/piano-intermediate-9",
  "piano-intermediate/10": "/lesson/piano-intermediate-10",
  "piano-intermediate/11": "/lesson/piano-intermediate-11",
  "piano-intermediate/12": "/lesson/piano-intermediate-12",
  "piano-intermediate/13": "/lesson/piano-intermediate-13",
  "piano-intermediate/14": "/lesson/piano-intermediate-14",
  "piano-intermediate/15": "/lesson/piano-intermediate-15",
  "piano-intermediate/16": "/lesson/piano-intermediate-16",
  "piano-intermediate/17": "/lesson/piano-intermediate-17",
  "piano-intermediate/18": "/lesson/piano-intermediate-18",
  "piano-intermediate/19": "/lesson/piano-intermediate-19",
  "piano-intermediate/20": "/lesson/piano-intermediate-20",
  "piano-intermediate/21": "/lesson/piano-intermediate-21",
  "piano-intermediate/22": "/lesson/piano-intermediate-22",
  "piano-intermediate/23": "/lesson/piano-intermediate-23",
  "piano-intermediate/24": "/lesson/piano-intermediate-24",
  "piano-intermediate/25": "/lesson/piano-intermediate-25",
  "piano-intermediate/26": "/lesson/piano-intermediate-26",
  "piano-intermediate/27": "/lesson/piano-intermediate-27",
  // Music Theory
  "music-theory/1": "/lesson/music-theory-1",
  "music-theory/2": "/lesson/music-theory-2",
  "music-theory/3": "/lesson/music-theory-3",
  "music-theory/4": "/lesson/music-theory-4",
  "music-theory/5": "/lesson/music-theory-5",
  "music-theory/6": "/lesson/music-theory-6",
  "music-theory/7": "/lesson/music-theory-7",
  "music-theory/8": "/lesson/music-theory-8",
  "music-theory/9": "/lesson/music-theory-9",
  "music-theory/10": "/lesson/music-theory-10",
  "music-theory/11": "/lesson/music-theory-11",
  "music-theory/12": "/lesson/music-theory-12",
  "music-theory/13": "/lesson/music-theory-13",
  "music-theory/14": "/lesson/music-theory-14",
  "music-theory/15": "/lesson/music-theory-15",
  "music-theory/16": "/lesson/music-theory-16",
  "music-theory/17": "/lesson/music-theory-17",
  "music-theory/18": "/lesson/music-theory-18",
  "music-theory/19": "/lesson/music-theory-19",
  "music-theory/20": "/lesson/music-theory-20",
  "music-theory/21": "/lesson/music-theory-21",
  "music-theory/22": "/lesson/music-theory-22",
  "music-theory/23": "/lesson/music-theory-23",
  "music-theory/24": "/lesson/music-theory-24",
  "music-theory/25": "/lesson/music-theory-25",
  "music-theory/26": "/lesson/music-theory-26",
  "music-theory/27": "/lesson/music-theory-27",
  "music-theory/28": "/lesson/music-theory-28",
  "music-theory/29": "/lesson/music-theory-29",
  "music-theory/30": "/lesson/music-theory-30",
  "music-theory/31": "/lesson/music-theory-31",
  "music-theory/32": "/lesson/music-theory-32",
  "music-theory/33": "/lesson/music-theory-33",
  "music-theory/34": "/lesson/music-theory-34",
  // Ear Training
  "ear-training/1": "/lesson/ear-training-1",
  "ear-training/2": "/lesson/ear-training-2",
  "ear-training/3": "/lesson/ear-training-3",
  "ear-training/4": "/lesson/ear-training-4",
  "ear-training/5": "/lesson/ear-training-5",
  "ear-training/6": "/lesson/ear-training-6",
  "ear-training/7": "/lesson/ear-training-7",
  "ear-training/8": "/lesson/ear-training-8",
  "ear-training/9": "/lesson/ear-training-9",
  "ear-training/10": "/lesson/ear-training-10",
  // Staff Notation
  "staff-notation/1": "/lesson/staff-notation-1",
  "staff-notation/2": "/lesson/staff-notation-2",
  "staff-notation/3": "/lesson/staff-notation-3",
  "staff-notation/4": "/lesson/staff-notation-4",
  "staff-notation/5": "/lesson/staff-notation-5",
  "staff-notation/6": "/lesson/staff-notation-6",
  // Other courses (3 each as sample)
  "the-beatles/1": "/lesson/the-beatles-1",
  "the-beatles/2": "/lesson/the-beatles-2",
  "the-beatles/3": "/lesson/the-beatles-3",
  "the-beatles/4": "/lesson/the-beatles-4",
  "the-beatles/5": "/lesson/the-beatles-5",
  "the-beatles/6": "/lesson/the-beatles-6",
  "the-beatles/7": "/lesson/the-beatles-7",
  "the-beatles/8": "/lesson/the-beatles-8",
  "the-beatles/9": "/lesson/the-beatles-9",
  "the-beatles/10": "/lesson/the-beatles-10",
  "the-beatles/11": "/lesson/the-beatles-11",
  "south-indian-songbook/1": "/lesson/south-indian-1",
  "south-indian-songbook/2": "/lesson/south-indian-2",
  "south-indian-songbook/3": "/lesson/south-indian-3",
  "south-indian-songbook/4": "/lesson/south-indian-4",
  "south-indian-songbook/5": "/lesson/south-indian-5",
  "south-indian-songbook/6": "/lesson/south-indian-6",
  "south-indian-songbook/7": "/lesson/south-indian-7",
  "south-indian-songbook/8": "/lesson/south-indian-8",
  "south-indian-songbook/9": "/lesson/south-indian-9",
  "south-indian-songbook/10": "/lesson/south-indian-10",
  "south-indian-songbook/11": "/lesson/south-indian-11",
  "south-indian-songbook/12": "/lesson/south-indian-12",
  "ed-sheeran/1": "/lesson/ed-sheeran-1",
  "ed-sheeran/2": "/lesson/ed-sheeran-2",
  "ed-sheeran/3": "/lesson/ed-sheeran-3",
  "ed-sheeran/4": "/lesson/ed-sheeran-4",
  "ed-sheeran/5": "/lesson/ed-sheeran-5",
  "ed-sheeran/6": "/lesson/ed-sheeran-6",
  "ed-sheeran/7": "/lesson/ed-sheeran-7",
  "ed-sheeran/8": "/lesson/ed-sheeran-8",
  "ed-sheeran/9": "/lesson/ed-sheeran-9",
  "ed-sheeran/10": "/lesson/ed-sheeran-10",
  "ed-sheeran/11": "/lesson/ed-sheeran-11",
  "ed-sheeran/12": "/lesson/ed-sheeran-12",
  "ed-sheeran/13": "/lesson/ed-sheeran-13",
  "ed-sheeran/14": "/lesson/ed-sheeran-14",
  "ed-sheeran/15": "/lesson/ed-sheeran-15",
  "ed-sheeran/16": "/lesson/ed-sheeran-16",
  "ed-sheeran/17": "/lesson/ed-sheeran-17",
};

const FEATURES = [
  {
    icon: "🎹",
    title: "Click-to-hear chord charts",
    desc: "Every Roman numeral analysis plays the chord the moment you click it. Hear the harmony, not just read it.",
  },
  {
    icon: "👂",
    title: "Ear training built in",
    desc: "Interval and chord recognition exercises woven directly into the lesson — no separate app needed.",
  },
  {
    icon: "🎵",
    title: "MIDI playback",
    desc: "Play along with the exact phrases Jason teaches. Loop any section at any speed.",
  },
  {
    icon: "📝",
    title: "Handwritten notes",
    desc: "Jason's own notation pages, one click away from the video — digitised, zoomable, always there.",
  },
  {
    icon: "🔁",
    title: "A-B loop & speed control",
    desc: "0.5× to 1.5× playback speed. Loop the tricky four bars until your fingers know them cold.",
  },
  {
    icon: "📐",
    title: "Animated theory diagrams",
    desc: "Circle of Fifths, scale patterns, voice-leading maps — they move as the lesson moves.",
  },
];

const COURSE_LIST = [
  { label: "The Beatles", count: 11 },
  { label: "Ed Sheeran", count: 17 },
  { label: "Piano Foundation", count: 35 },
  { label: "Piano Intermediate", count: 27 },
  { label: "Music Theory", count: 18 },
  { label: "Ear Training", count: 14 },
  { label: "Sing & Play", count: 10 },
  { label: "South Indian Songbook", count: 12 },
  { label: "Staff Notation", count: 6 },
];

function Index() {
  return (
    <div className="min-h-screen bg-nsm-bg">
      {/* Nav */}
      <header className="border-b border-nsm-border/60 px-6 py-4">
        <div className="mx-auto flex max-w-6xl items-center justify-between">
          <span className="font-display text-lg font-bold text-nsm-ink tracking-tight">
            Nathaniel School of Music
          </span>
          <a
            href="https://learn-music.nathanielschool.com"
            className="rounded-lg bg-amber-500 px-4 py-2 text-sm font-semibold text-black transition hover:bg-amber-400"
          >
            Go to my courses →
          </a>
        </div>
      </header>

      {/* Hero */}
      <section className="mx-auto max-w-6xl px-6 py-20 lg:py-28">
        <div className="text-xs font-semibold uppercase tracking-[0.2em] text-amber-400">
          Everything for Life · Interactive Companion
        </div>
        <h1 className="mt-4 font-display text-4xl font-bold leading-tight text-nsm-ink lg:text-6xl">
          Your lessons just got<br className="hidden lg:block" /> a whole lot deeper.
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-nsm-dim lg:text-lg">
          Every Everything for Life lesson now has an interactive companion built directly into your course page.
          Chord charts you can hear, notation you can zoom, ear trainers, MIDI playback — all without leaving the lesson.
        </p>
        <div className="mt-8 flex flex-wrap gap-4">
          <a
            href="https://learn-music.nathanielschool.com/login"
            className="rounded-xl bg-amber-500 px-6 py-3 text-sm font-bold text-black transition hover:bg-amber-400"
          >
            Log in to access your companion
          </a>
          <a
            href="https://learn-music.nathanielschool.com"
            className="rounded-xl border border-nsm-border px-6 py-3 text-sm font-semibold text-nsm-dim transition hover:border-amber-500/50 hover:text-nsm-ink"
          >
            Not enrolled yet? Learn more →
          </a>
        </div>
      </section>

      {/* Features */}
      <section className="border-t border-nsm-border/40 bg-nsm-card/30">
        <div className="mx-auto max-w-6xl px-6 py-16">
          <h2 className="font-display text-2xl font-bold text-nsm-ink lg:text-3xl">
            What's inside every lesson
          </h2>
          <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {FEATURES.map((f) => (
              <div key={f.title} className="rounded-2xl border border-nsm-border bg-nsm-card/60 p-6">
                <div className="text-3xl">{f.icon}</div>
                <div className="mt-3 font-display text-base font-semibold text-nsm-ink">{f.title}</div>
                <div className="mt-2 text-sm leading-relaxed text-nsm-dim">{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Courses included */}
      <section className="mx-auto max-w-6xl px-6 py-16">
        <h2 className="font-display text-2xl font-bold text-nsm-ink lg:text-3xl">
          Companion included across 9 courses
        </h2>
        <p className="mt-3 text-sm text-nsm-dim">156 lessons. All part of your Everything for Life membership.</p>
        <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {COURSE_LIST.map((c) => (
            <div key={c.label} className="rounded-xl border border-nsm-border bg-nsm-card/50 px-4 py-3">
              <div className="font-display text-sm font-semibold text-nsm-ink">{c.label}</div>
              <div className="mt-1 text-xs text-nsm-dim">{c.count} lessons</div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="border-t border-nsm-border/40 bg-nsm-card/30">
        <div className="mx-auto max-w-6xl px-6 py-16 text-center">
          <h2 className="font-display text-2xl font-bold text-nsm-ink lg:text-3xl">
            Already enrolled?
          </h2>
          <p className="mt-3 text-sm text-nsm-dim">
            Open any lesson in your course page — the companion is already there waiting for you.
          </p>
          <a
            href="https://learn-music.nathanielschool.com/login"
            className="mt-6 inline-block rounded-xl bg-amber-500 px-8 py-3 text-sm font-bold text-black transition hover:bg-amber-400"
          >
            Go to my lessons →
          </a>
        </div>
      </section>

      {/* FAQ */}
      <section className="mx-auto max-w-3xl px-6 py-16">
        <h2 className="font-display text-2xl font-bold text-nsm-ink lg:text-3xl">Questions about the companion</h2>
        <div className="mt-6 space-y-5">
          {FAQ.map((f) => (
            <div key={f.q}>
              <h3 className="font-display text-base font-semibold text-nsm-ink">{f.q}</h3>
              <p className="mt-1 text-sm leading-relaxed text-nsm-dim">{f.a}</p>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}

/** Redirect /admin to the LMS admin panel — the companion has no standalone admin */
function AdminRedirect() {
  window.location.replace("https://learn-music.nathanielschool.com/admin-ns");
  return null;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/admin" element={<AdminRedirect />} />
      <Route path="/lesson/circle-of-fifths-for-triads" element={<CircleOfFifthsTriads />} />
      {/* Sing & Play */}
      <Route path="/lesson/sing-and-play-1" element={<SingAndPlay1 />} />
      <Route path="/lesson/sing-and-play-2" element={<SingAndPlay2 />} />
      <Route path="/lesson/sing-and-play-3" element={<SingAndPlay3 />} />
      <Route path="/lesson/sing-and-play-4" element={<SingAndPlay4 />} />
      <Route path="/lesson/sing-and-play-5" element={<SingAndPlay5 />} />
      <Route path="/lesson/sing-and-play-6" element={<SingAndPlay6 />} />
      <Route path="/lesson/sing-and-play-7" element={<SingAndPlay7 />} />
      <Route path="/lesson/sing-and-play-8" element={<SingAndPlay8 />} />
      <Route path="/lesson/sing-and-play-9" element={<SingAndPlay9 />} />
      <Route path="/lesson/sing-and-play-10" element={<SingAndPlay10 />} />
      {/* Piano Foundation */}
      <Route path="/lesson/piano-foundation-1" element={<PianoFoundation1 />} />
      <Route path="/lesson/piano-foundation-2" element={<PianoFoundation2 />} />
      <Route path="/lesson/piano-foundation-3" element={<PianoFoundation3 />} />
      <Route path="/lesson/piano-foundation-4" element={<PianoFoundation4 />} />
      <Route path="/lesson/piano-foundation-5" element={<PianoFoundation5 />} />
      <Route path="/lesson/piano-foundation-6" element={<PianoFoundation6 />} />
      <Route path="/lesson/piano-foundation-7" element={<PianoFoundation7 />} />
      <Route path="/lesson/piano-foundation-8" element={<PianoFoundation8 />} />
      <Route path="/lesson/piano-foundation-9" element={<PianoFoundation9 />} />
      <Route path="/lesson/piano-foundation-10" element={<PianoFoundation10 />} />
      <Route path="/lesson/piano-foundation-11" element={<PianoFoundation11 />} />
      <Route path="/lesson/piano-foundation-12" element={<PianoFoundation12 />} />
      <Route path="/lesson/piano-foundation-13" element={<PianoFoundation13 />} />
      <Route path="/lesson/piano-foundation-14" element={<PianoFoundation14 />} />
      <Route path="/lesson/piano-foundation-15" element={<PianoFoundation15 />} />
      <Route path="/lesson/piano-foundation-16" element={<PianoFoundation16 />} />
      <Route path="/lesson/piano-foundation-17" element={<PianoFoundation17 />} />
      <Route path="/lesson/piano-foundation-18" element={<PianoFoundation18 />} />
      <Route path="/lesson/piano-foundation-19" element={<PianoFoundation19 />} />
      <Route path="/lesson/piano-foundation-20" element={<PianoFoundation20 />} />
      <Route path="/lesson/piano-foundation-21" element={<PianoFoundation21 />} />
      <Route path="/lesson/piano-foundation-22" element={<PianoFoundation22 />} />
      <Route path="/lesson/piano-foundation-23" element={<PianoFoundation23 />} />
      <Route path="/lesson/piano-foundation-24" element={<PianoFoundation24 />} />
      <Route path="/lesson/piano-foundation-25" element={<PianoFoundation25 />} />
      <Route path="/lesson/piano-foundation-26" element={<PianoFoundation26 />} />
      <Route path="/lesson/piano-foundation-27" element={<PianoFoundation27 />} />
      <Route path="/lesson/piano-foundation-28" element={<PianoFoundation28 />} />
      <Route path="/lesson/piano-foundation-29" element={<PianoFoundation29 />} />
      <Route path="/lesson/piano-foundation-30" element={<PianoFoundation30 />} />
      <Route path="/lesson/piano-foundation-31" element={<PianoFoundation31 />} />
      <Route path="/lesson/piano-foundation-32" element={<PianoFoundation32 />} />
      <Route path="/lesson/piano-foundation-33" element={<PianoFoundation33 />} />
      <Route path="/lesson/piano-foundation-34" element={<PianoFoundation34 />} />
      <Route path="/lesson/piano-foundation-35" element={<PianoFoundation35 />} />
      {/* Piano Intermediate */}
      <Route path="/lesson/piano-intermediate-1" element={<PianoIntermediate1 />} />
      <Route path="/lesson/piano-intermediate-2" element={<PianoIntermediate2 />} />
      <Route path="/lesson/piano-intermediate-3" element={<PianoIntermediate3 />} />
      <Route path="/lesson/piano-intermediate-4" element={<PianoIntermediate4 />} />
      <Route path="/lesson/piano-intermediate-5" element={<PianoIntermediate5 />} />
      <Route path="/lesson/piano-intermediate-6" element={<PianoIntermediate6 />} />
      <Route path="/lesson/piano-intermediate-7" element={<PianoIntermediate7 />} />
      <Route path="/lesson/piano-intermediate-8" element={<PianoIntermediate8 />} />
      <Route path="/lesson/piano-intermediate-9" element={<PianoIntermediate9 />} />
      <Route path="/lesson/piano-intermediate-10" element={<PianoIntermediate10 />} />
      <Route path="/lesson/piano-intermediate-11" element={<PianoIntermediate11 />} />
      <Route path="/lesson/piano-intermediate-12" element={<PianoIntermediate12 />} />
      <Route path="/lesson/piano-intermediate-13" element={<PianoIntermediate13 />} />
      <Route path="/lesson/piano-intermediate-14" element={<PianoIntermediate14 />} />
      <Route path="/lesson/piano-intermediate-15" element={<PianoIntermediate15 />} />
      <Route path="/lesson/piano-intermediate-16" element={<PianoIntermediate16 />} />
      <Route path="/lesson/piano-intermediate-17" element={<PianoIntermediate17 />} />
      <Route path="/lesson/piano-intermediate-18" element={<PianoIntermediate18 />} />
      <Route path="/lesson/piano-intermediate-19" element={<PianoIntermediate19 />} />
      <Route path="/lesson/piano-intermediate-20" element={<PianoIntermediate20 />} />
      <Route path="/lesson/piano-intermediate-21" element={<PianoIntermediate21 />} />
      <Route path="/lesson/piano-intermediate-22" element={<PianoIntermediate22 />} />
      <Route path="/lesson/piano-intermediate-23" element={<PianoIntermediate23 />} />
      <Route path="/lesson/piano-intermediate-24" element={<PianoIntermediate24 />} />
      <Route path="/lesson/piano-intermediate-25" element={<PianoIntermediate25 />} />
      <Route path="/lesson/piano-intermediate-26" element={<PianoIntermediate26 />} />
      <Route path="/lesson/piano-intermediate-27" element={<PianoIntermediate27 />} />
      {/* Music Theory */}
      <Route path="/lesson/music-theory-1" element={<MusicTheory1 />} />
      <Route path="/lesson/music-theory-2" element={<MusicTheory2 />} />
      <Route path="/lesson/music-theory-3" element={<MusicTheory3 />} />
      <Route path="/lesson/music-theory-4" element={<MusicTheory4 />} />
      <Route path="/lesson/music-theory-5" element={<MusicTheory5 />} />
      <Route path="/lesson/music-theory-6" element={<MusicTheory6 />} />
      <Route path="/lesson/music-theory-7" element={<MusicTheory7 />} />
      <Route path="/lesson/music-theory-8" element={<MusicTheory8 />} />
      <Route path="/lesson/music-theory-9" element={<MusicTheory9 />} />
      <Route path="/lesson/music-theory-10" element={<MusicTheory10 />} />
      <Route path="/lesson/music-theory-11" element={<MusicTheory11 />} />
      <Route path="/lesson/music-theory-12" element={<MusicTheory12 />} />
      <Route path="/lesson/music-theory-13" element={<MusicTheory13 />} />
      <Route path="/lesson/music-theory-14" element={<MusicTheory14 />} />
      <Route path="/lesson/music-theory-15" element={<MusicTheory15 />} />
      <Route path="/lesson/music-theory-16" element={<MusicTheory16 />} />
      <Route path="/lesson/music-theory-17" element={<MusicTheory17 />} />
      <Route path="/lesson/music-theory-18" element={<MusicTheory18 />} />
      <Route path="/lesson/music-theory-19" element={<MusicTheory19 />} />
      <Route path="/lesson/music-theory-20" element={<MusicTheory20 />} />
      <Route path="/lesson/music-theory-21" element={<MusicTheory21 />} />
      <Route path="/lesson/music-theory-22" element={<MusicTheory22 />} />
      <Route path="/lesson/music-theory-23" element={<MusicTheory23 />} />
      <Route path="/lesson/music-theory-24" element={<MusicTheory24 />} />
      <Route path="/lesson/music-theory-25" element={<MusicTheory25 />} />
      <Route path="/lesson/music-theory-26" element={<MusicTheory26 />} />
      <Route path="/lesson/music-theory-27" element={<MusicTheory27 />} />
      <Route path="/lesson/music-theory-28" element={<MusicTheory28 />} />
      <Route path="/lesson/music-theory-29" element={<MusicTheory29 />} />
      <Route path="/lesson/music-theory-30" element={<MusicTheory30 />} />
      <Route path="/lesson/music-theory-31" element={<MusicTheory31 />} />
      <Route path="/lesson/music-theory-32" element={<MusicTheory32 />} />
      <Route path="/lesson/music-theory-33" element={<MusicTheory33 />} />
      <Route path="/lesson/music-theory-34" element={<MusicTheory34 />} />
      {/* Ear Training */}
      <Route path="/lesson/ear-training-1" element={<EarTraining1 />} />
      <Route path="/lesson/ear-training-2" element={<EarTraining2 />} />
      <Route path="/lesson/ear-training-3" element={<EarTraining3 />} />
      <Route path="/lesson/ear-training-4" element={<EarTraining4 />} />
      <Route path="/lesson/ear-training-5" element={<EarTraining5 />} />
      <Route path="/lesson/ear-training-6" element={<EarTraining6 />} />
      <Route path="/lesson/ear-training-7" element={<EarTraining7 />} />
      <Route path="/lesson/ear-training-8" element={<EarTraining8 />} />
      <Route path="/lesson/ear-training-9" element={<EarTraining9 />} />
      <Route path="/lesson/ear-training-10" element={<EarTraining10 />} />
      {/* Staff Notation */}
      <Route path="/lesson/staff-notation-1" element={<StaffNotation1 />} />
      <Route path="/lesson/staff-notation-2" element={<StaffNotation2 />} />
      <Route path="/lesson/staff-notation-3" element={<StaffNotation3 />} />
      <Route path="/lesson/staff-notation-4" element={<StaffNotation4 />} />
      <Route path="/lesson/staff-notation-5" element={<StaffNotation5 />} />
      <Route path="/lesson/staff-notation-6" element={<StaffNotation6 />} />
      {/* Sample lessons in other courses */}
      <Route path="/lesson/the-beatles-1" element={<Beatles1 />} />
      <Route path="/lesson/the-beatles-2" element={<Beatles2 />} />
      <Route path="/lesson/the-beatles-3" element={<Beatles3 />} />
      <Route path="/lesson/the-beatles-4" element={<Beatles4 />} />
      <Route path="/lesson/the-beatles-5" element={<Beatles5 />} />
      <Route path="/lesson/the-beatles-6" element={<Beatles6 />} />
      <Route path="/lesson/the-beatles-7" element={<Beatles7 />} />
      <Route path="/lesson/the-beatles-8" element={<Beatles8 />} />
      <Route path="/lesson/the-beatles-9" element={<Beatles9 />} />
      <Route path="/lesson/the-beatles-10" element={<Beatles10 />} />
      <Route path="/lesson/the-beatles-11" element={<Beatles11 />} />
      <Route path="/lesson/south-indian-1" element={<SouthIndian1 />} />
      <Route path="/lesson/south-indian-2" element={<SouthIndian2 />} />
      <Route path="/lesson/south-indian-3" element={<SouthIndian3 />} />
      <Route path="/lesson/south-indian-4" element={<SouthIndian4 />} />
      <Route path="/lesson/south-indian-5" element={<SouthIndian5 />} />
      <Route path="/lesson/south-indian-6" element={<SouthIndian6 />} />
      <Route path="/lesson/south-indian-7" element={<SouthIndian7 />} />
      <Route path="/lesson/south-indian-8" element={<SouthIndian8 />} />
      <Route path="/lesson/south-indian-9" element={<SouthIndian9 />} />
      <Route path="/lesson/south-indian-10" element={<SouthIndian10 />} />
      <Route path="/lesson/south-indian-11" element={<SouthIndian11 />} />
      <Route path="/lesson/south-indian-12" element={<SouthIndian12 />} />
      <Route path="/lesson/ed-sheeran-1" element={<EdSheeran1 />} />
      <Route path="/lesson/ed-sheeran-2" element={<EdSheeran2 />} />
      <Route path="/lesson/ed-sheeran-3" element={<EdSheeran3 />} />
      <Route path="/lesson/ed-sheeran-4" element={<EdSheeran4 />} />
      <Route path="/lesson/ed-sheeran-5" element={<EdSheeran5 />} />
      <Route path="/lesson/ed-sheeran-6" element={<EdSheeran6 />} />
      <Route path="/lesson/ed-sheeran-7" element={<EdSheeran7 />} />
      <Route path="/lesson/ed-sheeran-8" element={<EdSheeran8 />} />
      <Route path="/lesson/ed-sheeran-9" element={<EdSheeran9 />} />
      <Route path="/lesson/ed-sheeran-10" element={<EdSheeran10 />} />
      <Route path="/lesson/ed-sheeran-11" element={<EdSheeran11 />} />
      <Route path="/lesson/ed-sheeran-12" element={<EdSheeran12 />} />
      <Route path="/lesson/ed-sheeran-13" element={<EdSheeran13 />} />
      <Route path="/lesson/ed-sheeran-14" element={<EdSheeran14 />} />
      <Route path="/lesson/ed-sheeran-15" element={<EdSheeran15 />} />
      <Route path="/lesson/ed-sheeran-16" element={<EdSheeran16 />} />
      <Route path="/lesson/ed-sheeran-17" element={<EdSheeran17 />} />
      {/* Fallback: any /lesson/<slug> without a hand-built component above
          renders from live CompanionContent. Placed LAST so all 163 explicit
          routes always win — this can never shadow an existing lesson. */}
      <Route path="/course/sight-reading" element={<SightReadingCourse />} />
      {/* One component serves every Sight Reading piece — adding a piece means
          adding score data, never a route. LessonRouter picks the renderer,
          because React Router cannot match a param inside part of a segment. */}
      <Route path="/lesson/:slug" element={<LessonRouter />} />
      {/* A student arrived on /learn/sight-reading from a link we had given
          out and got a blank white page — there was no catch-all, so any URL
          that missed every route above rendered literally nothing. Keep the
          old address working, and make sure a wrong one says so. */}
      <Route path="/learn/sight-reading" element={<Navigate to="/course/sight-reading" replace />} />
      <Route path="/learn/:slug" element={<Navigate to="/course/sight-reading" replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
